import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import FullWidthContentColor from "./FullWidthContentColor";
import TrailBlock from "./TrailBlock";
import { nanoid } from "nanoid";

class TrailsListColorTemplate extends React.Component {
  render() {
    let { title } = this.props;
    const { data } = this.props;
    const { backgroundColor } = this.props;
    const { from } = this.props;

    const { edges: posts } = data.allMarkdownRemark;
    const { frontmatter: config } = data.config;

    if (!title) {
      title = "Popular Mountain Bike Trails We Shuttle";
    }

    let { departures } = data;

    let departureData = [];

    departures = departures.edges;

    departures.forEach((departure) => {
      departureData[departure.node.frontmatter.title] = departure.node;
    });

    let rows = [];

    posts.forEach(({ node: post }) => {
      let {
        logo,
        miles,
        descent,
        elevationGain,
        high,
        low,
        aveGrade,
        maxGrade,
        rating,
        afterRating,
        map,
        note,
      } = post.frontmatter.trail;
      let display = [];

      if (miles) {
        display.push(miles + " miles");
      }
      if (descent) {
        display.push(descent + " descent");
      }
      if (elevationGain) {
        display.push(elevationGain + " elevation gain");
      }
      if (high) {
        display.push(high + " high");
      }
      if (low) {
        display.push(low + " low");
      }
      if (aveGrade) {
        display.push(aveGrade + " avg. grade");
      }
      if (maxGrade) {
        display.push(maxGrade + " max grade");
      }

      let slug = post.fields.slug;
      let title = post.frontmatter.title;
      let price = post.frontmatter.price;

      let gallerySlug = slug.replace("/mtb-shuttles/", "/galleries/");
      let pickups = [];
      if (post.frontmatter.pickups && post.frontmatter.pickups.pickup) {
        pickups = post.frontmatter.pickups.pickup;
      }

      let videoSlug = post.frontmatter.trail.videos;

      let related;
      if (post.frontmatter.trail.related) {
        related = post.frontmatter.trail.related.trails;
      }

      if (!note) note = "";
      price = updatePriceFromConfig(price, post.fields.slug, config);
      if (from) {
        let obj = pickups.find((o) => o.title === from);

        if (obj) {
          rows.push(
            <React.Fragment key={nanoid()}>
              <TrailBlock
                logo={logo}
                title={`${title}`}
                note={note}
                display={display.join(" / ")}
                rating={rating}
                afterRating={afterRating}
                slug={post.fields.slug}
                gallerySlug={gallerySlug}
                videoSlug={videoSlug}
                mapSlug={map}
                pickups={pickups}
                departures={departureData}
                related={related}
                price={price}
              />
            </React.Fragment>
          );
        }
      } else {
        rows.push(
          <React.Fragment key={nanoid()}>
            <TrailBlock
              logo={logo}
              title={`${title}`}
              note={note}
              display={display.join(" / ")}
              rating={rating}
              afterRating={afterRating}
              slug={post.fields.slug}
              gallerySlug={gallerySlug}
              videoSlug={videoSlug}
              mapSlug={map}
              pickups={pickups}
              departures={departureData}
              related={related}
              price={price}
            />
          </React.Fragment>
        );
      }
    });

    return (
      <FullWidthContentColor
        title={title}
        content={rows}
        backgroundColor={backgroundColor}
      />
    );
  }
}

TrailsListColor.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function TrailsListColor({
  backgroundColor = "#eaeaea",
  from = "",
  title = "",
}) {
  return (
    <StaticQuery
      query={graphql`
        query TrailsListColorQuery {
          allMarkdownRemark(
            sort: { frontmatter: { meta: { sortOrder: ASC } } }
            filter: {
              frontmatter: { templateKey: { eq: "mtb-shuttles-post" } }
            }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  summary
                  pickups {
                    pickup {
                      title
                    }
                  }
                  price
                  trail {
                    logo {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 100
                          layout: FULL_WIDTH
                          placeholder: BLURRED
                        )
                      }
                    }
                    miles
                    descent
                    elevationGain
                    high
                    low
                    aveGrade
                    maxGrade
                    rating
                    afterRating
                    map
                    note
                    videos
                    related {
                      trails {
                        title
                        slug
                        image {
                          childImageSharp {
                            gatsbyImageData(
                              quality: 100
                              layout: FULL_WIDTH
                              placeholder: BLURRED
                            )
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          departures: allMarkdownRemark(
            sort: { frontmatter: { meta: { sortOrder: ASC } } }
            filter: {
              frontmatter: { templateKey: { eq: "departure-locations-post" } }
            }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  subtitle
                  listingSubtitle
                  image {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 100
                        layout: FULL_WIDTH
                        placeholder: BLURRED
                      )
                    }
                  }
                  googleMap
                }
              }
            }
          }
          config: markdownRemark(
            frontmatter: { templateKey: { eq: "configuration" } }
          ) {
            frontmatter {
              pricing {
                price {
                  slug
                  price
                }
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <TrailsListColorTemplate
          data={data}
          count={count}
          backgroundColor={backgroundColor}
          from={from}
          title={title}
        />
      )}
    />
  );
}

function updatePriceFromConfig(price, slug, config) {
  //console.log(price, slug, config);
  let pricesArr = [],
    prices = config.pricing.price;

  prices.forEach((element) => {
    pricesArr[element.slug] = element.price;
  });
  if (pricesArr[slug]) {
    return pricesArr[slug];
  } else {
    return price;
  }
}
